import styled from 'styled-components';
import { motion } from 'framer-motion';
import { getNotificationPosition, getListDirection } from './helpers';
export var Container = styled(motion.div).withConfig({
  displayName: "elements__Container",
  componentId: "sc-17pt21z-0"
})(["margin-bottom:1rem;"]);
export var NotificationsList = styled.div.withConfig({
  displayName: "elements__NotificationsList",
  componentId: "sc-17pt21z-1"
})(["position:fixed;display:flex;width:32rem;", ";", ";"], function (_ref) {
  var placement = _ref.placement;
  return getListDirection(placement);
}, function (_ref2) {
  var placement = _ref2.placement;
  return getNotificationPosition(placement);
});